<template>
  <div>
    <el-card>
      <app-breadcrumb :items="items"></app-breadcrumb>
    </el-card>
    <br />
    <el-card>
      <h2 class="title">
        Notificaciones agrupadas
        <i
          class="custom__icon"
          :class="(opentableShowGroup ? 'icon-cerrar' : 'icon-ver_mas02')"
          @click="toggle('tableShowGroup')"
        ></i>
      </h2>
      <br />

      <app-table-paginate
        :key="reloadTableArgrupada"
        v-show="tableShowGroup"
        routeDelete="no"
        selection="no"
        :tableQuery="getList"
        :tableColumns="tableColumns"
        :limit="limit"
        :search="true"
        :noDisplayActions="true"
        :expand="true"
        :expandData="'notifications'"
        :expandColumns="expandColumns"
      ></app-table-paginate>
    </el-card>

    <br />

    <el-card>
      <h2 class="title">
        Notificaciones
        <i
          class="custom__icon"
          :class="(opentableShow ? 'icon-cerrar' : 'icon-ver_mas02')"
          @click="toggle('tableShow')"
        ></i>
      </h2>
      <br />
      <app-table-paginate
        :key="reloadTableNotificaciones"
        v-show="tableShow"
        routeDelete="no"
        selection="no"
        :tableQuery="getListNotifications"
        :tableColumns="expandColumns"
        :limit="10000"
        :search="true"
        :noDisplayActions="true"
      ></app-table-paginate>
    </el-card>

    <br />

    <el-card>
      <h2 class="title">
        Gráficas
        <i
          class="custom__icon"
          :class="(opentableShowChart ? 'icon-cerrar' : 'icon-ver_mas02')"
          @click="toggle('tableShowChart')"
        ></i>
      </h2>
      <el-row :gutter="24" v-show="tableShowChart">
        <el-col :span="16">
          <app-chart
            v-if="dataSource"
            type="dragcolumn2d"
            :width="width"
            :height="height"
            :dataFormat="dataFormat"
            :dataSource="dataSource"
          ></app-chart>
        </el-col>
        <el-col :span="8">
          <app-chart
            type="pie2d"
            :width="width"
            :height="height"
            :dataFormat="dataFormat"
            :dataSource="dataSource2"
          ></app-chart>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import moment from "moment-timezone";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import breadcrumb from "@/components/_commons/breadcrumb";
import chart from "@/components/_commons/chart";

export default {
  name: "historico-acceso-usuario",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-breadcrumb": breadcrumb,
    "app-chart": chart
  },
  created() {
    this.get();
    this.getUser();
  },
  data() {
    return {
      reloadTableArgrupada: 0,
      reloadTableNotificaciones: 0,
      width: "100%",
      height: "400",
      dataFormat: "json",
      dataSource: {
        chart: {
          caption: "Agrupación de notificaciones por escritorio",
          yaxismaxvalue: this.max,
          theme: "fusion",
          plotToolText: "<b>$label</b><br>$seriesName: <b>$dataValue</b>"
        },
        categories: [
          {
            category: null
          }
        ],
        dataset: null
      },
      dataSource2: {
        chart: {
          bgColor: "FFFFFF",
          caption: "Notificaciones",
          plottooltext: "<b>$percentValue</b> de notificaciones $label ",
          showLegend: "1",
          showPercentValues: "1",
          legendPosition: "bottom",
          useDataPlotColorForLabels: "1",
          enableMultiSlicing: "0",
          theme: "fusion",
          showlegend: "0"
        },
        data: null
      },

      items: [
        {
          path: "/auditoria/",
          label: "auditoria"
        },
        {
          path: "/auditoria/user-notifications",
          label: "Usuarios"
        },
        {
          path: "/auditoria/notification-users",
          label: "Usuarios"
        },
        {
          path: "/auditoria/access-history/user-history/",
          label: "Notificaciones usuario"
        }
      ],

      user_id: this.$route.params.user_id,
      listAPI: false,
      notificationsAPI: false,
      strMonths: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      tableColumns: [
        {
          prop: "title",
          label: "Tipo"
        }
      ],
      expandColumns: [
        {
          prop: "title",
          label: "Notificación"
        },
        {
          prop: "date",
          label: "Fecha"
        },
        {
          prop: "read",
          label: "Leída"
        },
        {
          prop: "comprendido",
          label: "Comprendida"
        },
        {
          prop: "link",
          label: "URL"
        }
      ],
      searchQuery: "",
      deleterow: false,
      limit: 10,
      tableShow: false,
      tableShowGroup: false,
      opentableShow: false,
      opentableShowGroup: false,
      tableShowChart: false,
      opentableShowChart: false,
      max: 0
    };
  },
  methods: {
    toggle(table) {
      this["open" + table] = !this["open" + table];
      this[table] = !this[table];
    },
    async get() {
      const response = await ApiService.post("auditoria/user-notification", {
        token: localStorage.getItem("token"),
        id: this.$route.params.user
      });

      let notificaciones = [];

      let read = 0,
        noread = 0,
        comprendido = 0,
        nocomprendido = 0,
        categories = [],
        seriesLeidos = [
          {
            seriesname: "Leídos",
            data: []
          }
        ],
        seriesNoLeidos = [
          {
            seriesname: "No leídos",
            data: []
          }
        ];

      this.listAPI = response.data.map(e => {
        categories.push({
          label: e.title
        });
        let i = 0;
        e.notifications.map(r => {
          if (r.read) {
            r.read = 1;
            read++;
          } else {
            r.read = 2;
            noread++;
          }
          if (r.comprendido) {
            r.comprendido = 1;
            comprendido++;
          } else {
            r.comprendido = 2;
            nocomprendido++;
          }
          i++;
          notificaciones.push(r);
          return r;
        });
        i > this.max ? (this.max = i) : false;
        seriesLeidos[0].data.push({
          value: read,
          alpha: "100"
        });

        seriesNoLeidos[0].data.push({
          value: noread,
          alpha: "100"
        });
        return e;
      });
      this.notificationsAPI = notificaciones;
      this.dataSource.categories[0].category = categories;
      seriesLeidos.seriesname = "Leídos";
      seriesNoLeidos.seriesname = "No leídos";
      this.dataSource.dataset = seriesLeidos.concat(seriesNoLeidos);
      this.dataSource2.data = [
        {
          label: "Leídas",
          value: read,
          color: "#105b4a"
        },
        {
          label: "No leídas",
          value: noread,
          color: "#fb4513"
        }
      ];
      this.reloadTableNotificaciones++;
      this.reloadTableArgrupada++;
    },
    async getUser() {
      let data = {
        table: "users",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        relationship: [],
        id: this.$route.params.user,
        header: [
          {
            title: "Nombre",
            path: "name",
            type: "text",
            key: false,
            options: []
          },
          {
            title: "Apellido",
            path: "last_name",
            type: "text",
            key: false,
            options: []
          }
        ]
      };

      const response = await ApiService.post("dashboard/listtable", data);
      if (response) {
        this.items.push({
          path:
            "/auditoria/access-history/user-history/" + this.$route.params.user,
          label: response.data.name + " " + response.data.last_name
        });
      }
    }
  },
  computed: {
    getList() {
      return this.listAPI;
    },
    getListNotifications() {
      return this.notificationsAPI;
    }
  },
  filters: {
    moment: function(date) {
      return moment(date)
        .tz("Europe/Madrid")
        .format("DD/MM/YY");
    }
  }
};
</script>

<style lang="scss" scoped>
.el-breadcrumb {
  margin-bottom: 0 !important;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#chartobject-1 {
  svg {
    background-color: red !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/auditoria/notifications/user.vue